import React from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';
import { toaster } from 'evergreen-ui';
import { isAdminSelector, isLocalAdminSelector } from 'Services/auth.service';
import { useGetRegionsQuery } from 'Services/api/regionsApi';
import { stationFullSelector, stationsFullSelector } from 'Features/App/Dictionaries/selectors';
import PrivilegesPage from "../../Privileges/PrivilegesPage";
import {useGetPrivilegesQuery} from "../../Privileges/PrivilegesApi";

const UsersRouter = React.lazy(() => import('./Users.User'));
const Roles = React.lazy(() => import('./Users.Roles'));
const RolesForm = React.lazy(() => import('./Users.Roles.Form'));
const Rules = React.lazy(() => import('./Users.Rules'));
// const Logs = React.lazy(() => import('./Users.Logs'));

function PrivilegesRules() {
    const { data, isLoading } = useGetPrivilegesQuery();
    return (
        <PrivilegesPage
            data={data}
            isLoading={isLoading}
        />
    )
}

export default function SettingsUsersRouter() {
  const isAdmin = useSelector(isAdminSelector);
  const isLocalAdmin = useSelector(isLocalAdminSelector);
  React.useEffect(() => {
    if (!isAdmin && !isLocalAdmin) toaster.warning('Нет прав для просмотра настроек!');
  }, [isAdmin, isLocalAdmin]);

  if (!isAdmin && !isLocalAdmin) return <Navigate to="/" />;

  return (
    <Routes>
      <Route index path="/" element={<Navigate to="users" replace />} />

      <Route path="users/*" element={<UsersRouter />} />
      <Route path="roles" element={<Roles />} />
      <Route path="roles/new" element={<RolesForm />} />

      <Route
        path="regions"
        element={<RegionsRules />}
      />
      <Route
        path="stations"
        element={<StationsRules />}
      />


      <Route
        path="privileges"
        element={(<PrivilegesRules/>)}
      />
      {/*<Route path="logs" element={<Logs />} />*/}
      <Route path="*" element={<Navigate to="users" replace />} />
    </Routes>
  );
}

function RegionsRules() {
  const { data, isLoading } = useGetRegionsQuery();
  return (
    <Rules
      data={data}
      isLoading={isLoading}
      type="region"
    />
  );
}

function StationsRules() {
  const stations = useSelector(stationsFullSelector);
  return (
    <Rules
      data={Object.values(stations).map((station) => station.station)}
      type="station"
    />
  );
}
